module.exports = __webpack_public_path__ + "static/media/Logo_and_strapline.dd83acf3.png";